var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-team-wrapper",attrs:{"df":"","fdr":""}},_vm._l((_vm.teams),function(team){return _c('div',{key:team.objectId},[_c('div',{staticClass:"card-tag",attrs:{"df":"","fic":"","fjc":""}},[_vm._v(_vm._s(team.name))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }